import ScreenStateInfo from './ScreenStateInfo';
export * from './ScreenStateInfo';
export default ScreenStateInfo;
